import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

export const signUpWithEmail = createServerFn({ method: "POST" })
  .inputValidator((input: unknown) =>
    z
      .object({
        email: z.string().email(),
        password: z.string().min(8).max(200),
        redirectTo: z.string().url(),
        acceptTerms: z.literal(true),
        withDraft: z.boolean().optional(),
      })
      .parse(input),
  )
  .handler(async ({ data }) => {
    const { signUpWithEmailHandler } = await import("./auth-emails.server");
    return signUpWithEmailHandler(data);
  });

export const requestPasswordReset = createServerFn({ method: "POST" })
  .inputValidator((input: unknown) =>
    z.object({ email: z.string().email(), redirectTo: z.string().url() }).parse(input),
  )
  .handler(async ({ data }) => {
    const { requestPasswordResetHandler } = await import("./auth-emails.server");
    return requestPasswordResetHandler(data);
  });

export const resendSignupCode = createServerFn({ method: "POST" })
  .inputValidator((input: unknown) =>
    z.object({ email: z.string().email(), redirectTo: z.string().url() }).parse(input),
  )
  .handler(async ({ data }) => {
    const { resendSignupCodeHandler } = await import("./auth-emails.server");
    return resendSignupCodeHandler(data);
  });

export const verifySignupCode = createServerFn({ method: "POST" })
  .inputValidator((input: unknown) =>
    z
      .object({
        email: z.string().email(),
        code: z.string().trim().min(4).max(8),
      })
      .parse(input),
  )
  .handler(async ({ data }) => {
    const { verifySignupCodeHandler } = await import("./auth-emails.server");
    return verifySignupCodeHandler(data);
  });

export const requestMagicLink = createServerFn({ method: "POST" })
  .inputValidator((input: unknown) =>
    z.object({ email: z.string().email(), redirectTo: z.string().url() }).parse(input),
  )
  .handler(async ({ data }) => {
    const { requestMagicLinkHandler } = await import("./auth-emails.server");
    return requestMagicLinkHandler(data);
  });
